import { fetchNextAvailable } from '@packages/cortex-sdk';
import { useEffect, useState } from 'react';

export default function useNextAvailableByPractitioner(
  practitionerIds: string[],
  serviceId: string,
  clinicId: string,
  fromDate: string,
) {
  const [fetchedNextAvailable, setFetchedNextAvailable] = useState<
    Record<string, { startTime: string }>
  >({});

  useEffect(() => {
    const getAllNextAvailable = async () => {
      const responses = await Promise.all(
        practitionerIds.map(async (practitionerId) => {
          const timeSlot = await fetchNextAvailable({
            practitionerId,
            serviceId,
            clinicId,
          });
          return { practitionerId, timeSlot };
        }),
      );
      const fetchedNextAvailableTimeSlotsByPractitionerId = responses.reduce(
        (acc: Record<string, { startTime: string }>, current) => {
          if (current.timeSlot) {
            acc[current.practitionerId] = current.timeSlot;
          }
          return acc;
        },
        {},
      );
      setFetchedNextAvailable(fetchedNextAvailableTimeSlotsByPractitionerId);
    };
    getAllNextAvailable();
  }, [practitionerIds, serviceId, clinicId, fromDate]);

  return fetchedNextAvailable;
}
